import React, { useState, useEffect } from "react";
import { useHistory,Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableFooter from "@material-ui/core/TableFooter";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import ProductMatchingGroupListItem from "./ProductMatchingGroupListItem";

import MergeGroupDialog from "./MergeGroupDialog";
import SimilarGroupDialog from "./SimilarGroupDialog";


import SearchBox from "./SearchBox";
import CompanyDropDownBox from "./CompanyDropDownBox";
import {  useSelector } from "react-redux";
import axios from "axios";
import envConfig from "../../bin/env.config";
import store from "../../store/store";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  table: {
    minWidth: 350,
    '& tbody>.MuiTableRow-root:hover': {
      background: '#DDD',
    }
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
}));

export default function Products2ReviewPage(props) {
  const history = useHistory();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [groups, setGroups] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isMergeGroupDialogOpen, setIsMergeGroupDialogOpen] = useState(false);
  const [isSimilarGroupDialogOpen, setIsSimilarGroupDialogOpen] = useState(false);
  const [currentProductMatchingGroup, setCurrentProductMatchingGroup] = useState(undefined);
  const companies = useSelector(state => state.companies.companies);
  const token = useSelector(state => state.session.token);
  const selectedCompany = companies&&companies.find(company=>company.selected);

  const loader = document.querySelector(".loader");
  // const updateContainer = document.querySelector(".updateContainer");

  // if you want to show the loader when React loads data again
  const showLoader = () => loader?.classList?.remove("loader--hide");
  const hideLoader = () => loader?.classList?.add("loader--hide");

  useEffect(() => {
    const fetchData = async () => {
      showLoader();
      setIsLoading(true);
      try {
        const skip = page * rowsPerPage;
        const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/groups?orderBy=${orderBy}&order=${order}&limit=${rowsPerPage}&skip=${skip}&c=${selectedCompany ? selectedCompany._id : 0}`;
        const result = await axios.post(
          url,
          { q: searchText },
          {
            headers: {
              Authorization: JSON.stringify(store.getState().session.token),
            },
          }
        );
        setGroups(result.data.data || []);
        if (result.data.total !== undefined) {
          setTotalCount(result.data.total);
        } else if (result.data.count !== undefined) {
          setTotalCount(result.data.count);
        } else {
          setTotalCount(
            result.data.data.length < rowsPerPage
              ? page * rowsPerPage + result.data.data.length
              : (page + 1) * rowsPerPage + 1
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setGroups([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false);
        hideLoader();
      }
    };

    fetchData();
  }, [searchText, page, rowsPerPage, order, orderBy, selectedCompany]);

  const doSearch = (q) => {
    setSearchText(q);
    setPage(0);
  };
  const handleSortClick = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handlePageSelect = (event) => {
    setPage(parseInt(event.target.value, 10));
  };
  const handViewSimilarGroupsClick = ()=>{
    history.push("/similar-groups");
  }
  const handCreateNewGroupClick = ()=>{
    history.push("/create-new-group");
  }
  const openMergeGroupDialog = (productMatchingGroup) => {
    setCurrentProductMatchingGroup(productMatchingGroup);
    setIsMergeGroupDialogOpen(true);
  };
  const handleMergeGroupDialogClose = () => {
    setIsMergeGroupDialogOpen(false);
  };
  const openSimilarGroupDialog = (productMatchingGroup) => {
    setCurrentProductMatchingGroup(productMatchingGroup);
    setIsSimilarGroupDialogOpen(true);
  };
  const handleSimilarGroupDialogClose = () => {
    setIsSimilarGroupDialogOpen(false);
  };

  return (
    <>
      <AppBar position="sticky" color="inherit">
        <Toolbar>
          <IconButton
            color="inherit"
            onClick={() => history.goBack()}
            aria-label="Close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Product matching groups
          </Typography>
          <Button variant="contained" color="primary" onClick={handCreateNewGroupClick}>
           Create new group
          </Button>
          <CompanyDropDownBox/>
          <SearchBox doSearch={doSearch} value={searchText} searchOnChange={false} />&nbsp;
          <Button variant="contained" color="primary" onClick={handViewSimilarGroupsClick}>
          <Hidden mdDown> View </Hidden> Similar <Hidden mdDown>Groups</Hidden>
          </Button>
        </Toolbar>
      </AppBar>
      <Grid
        className={classes.root}
        container
        alignItems="center"
        justifyContent="center"
      >
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={9} align="center" style={{ padding: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", padding: "8px", flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Typography variant="body2" style={{ whiteSpace: "nowrap" }}>
                          Go to page:
                        </Typography>
                        <Select
                          value={page}
                          onChange={handlePageSelect}
                          style={{ minWidth: "80px" }}
                          size="small"
                          disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                        >
                          {Array.from({ length: Math.max(1, Math.ceil(totalCount / rowsPerPage)) }, (_, i) => (
                            <MenuItem key={i} value={i}>
                              {i + 1}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <TablePagination
                        component="div"
                        count={totalCount}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                      />
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <Hidden mdDown>
                    <TableCell align="center">
                      <TableSortLabel
                        active={orderBy === "group_id"}
                        direction={orderBy === "group_id" ? order : "asc"}
                        onClick={() => handleSortClick("group_id")}
                      >
                        ID
                        {orderBy === "group_id" ? (
                          <span className={classes.visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </span>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center">Remove</TableCell>
                    <TableCell align="center">Image eg.</TableCell>
                  </Hidden>
                  <TableCell align="left">
                    <TableSortLabel
                      active={orderBy === "name"}
                      direction={orderBy === "name" ? order : "asc"}
                      onClick={() => handleSortClick("name")}
                    >
                      Name eg.
                      {orderBy === "name" ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="left">
                    <TableSortLabel
                      active={orderBy === "brand_name"}
                      direction={orderBy === "brand_name" ? order : "asc"}
                      onClick={() => handleSortClick("brand_name")}
                    >
                      Brand.
                      {orderBy === "brand_name" ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell align="center">
                    <TableSortLabel
                      active={orderBy === "size"}
                      direction={orderBy === "size" ? order : "asc"}
                      onClick={() => handleSortClick("size")}
                    >
                      Size eg.
                      {orderBy === "size" ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                  {/* <TableCell align="center">Label</TableCell>
                  <TableCell align="right">
                    <TableSortLabel
                      active={orderBy === "products_count"}
                      direction={orderBy === "products_count" ? order : "asc"}
                      onClick={() => handleSortClick("products_count")}
                    >
                      #Products.
                      {orderBy === "products_count" ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell> */}
                  {/* <TableCell align="right">
                    <TableSortLabel
                      active={orderBy === "match_score_avg"}
                      direction={orderBy === "match_score_avg" ? order : "asc"}
                      onClick={() => handleSortClick("match_score_avg")}
                    >
                      Avg Score.
                      {orderBy === "match_score_avg" ? (
                        <span className={classes.visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </TableCell> */}
                  <TableCell align="center">Counts</TableCell>
                  <TableCell align="center">Tags</TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" style={{ padding: 0 }}>
                      <CircularProgress size={16} />
                    </TableCell>
                  </TableRow>
                ) : (
                  groups.map((row, i) => (
                    <ProductMatchingGroupListItem
                      key={row.id != null ? row.id : i}
                      productMatching={row}
                      openMergeGroupDialog={openMergeGroupDialog}
                      openSimilarGroupDialog={openSimilarGroupDialog}
                    />
                  ))
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={9} align="center" style={{ padding: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", padding: "8px", flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Typography variant="body2" style={{ whiteSpace: "nowrap" }}>
                          Go to page:
                        </Typography>
                        <Select
                          value={page}
                          onChange={handlePageSelect}
                          style={{ minWidth: "80px" }}
                          size="small"
                          disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                        >
                          {Array.from({ length: Math.max(1, Math.ceil(totalCount / rowsPerPage)) }, (_, i) => (
                            <MenuItem key={i} value={i}>
                              {i + 1}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <TablePagination
                        component="div"
                        count={totalCount}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Grid>

      <MergeGroupDialog open={isMergeGroupDialogOpen} onClose={handleMergeGroupDialogClose} currentProductMatchingGroup={currentProductMatchingGroup}/>
      <SimilarGroupDialog open={isSimilarGroupDialogOpen} onClose={handleSimilarGroupDialogClose} currentProductMatchingGroup={currentProductMatchingGroup}/>
    </>
  );
}
